import React, { useRef, useState } from "react";
import classNames from "classnames";

import Loader from "../Loader";

interface Props {
  id?: string;
  className?: string;
  disabled?: boolean;
  isLoading?: boolean;
  label?: React.ReactNode;
  onChange: (input: string) => void;
  placeholder?: string;
  type?: string;
  value?: string;
}

const SearchBar: React.FC<Props> = ({
  id = "caprx-data-table-search-input",
  className,
  disabled,
  isLoading = false,
  label = "Filter table",
  onChange,
  placeholder = "",
  type,
  value = "",
}: Props): JSX.Element => {
  const [shouldAnimate, setShouldAnimate] = useState(false);
  const inputRef = useRef(null);

  const changeHandler = (input: React.ChangeEvent<HTMLInputElement>): void => {
    const term = input.currentTarget.value.trim();
    onChange(term);
  };

  let inputHasValue = false;

  if (inputRef.current) {
    inputHasValue = inputRef.current.value.trim().length > 0 || value?.length > 0;
  }

  const formElemRootClasses = classNames(className, "caprx-f-elem-root", {
    "caprx-f-elem-animate": shouldAnimate || inputHasValue,
  });

  return (
    <>
      {isLoading && (
        <span className="search-loader-container">
          <Loader color="lightgrey" solid size="9px" />
        </span>
      )}
      <div className={formElemRootClasses}>
        <input
          id={id}
          type={type}
          disabled={disabled}
          className="caprx-f-elem-input"
          onFocus={(): void => setShouldAnimate(true)}
          onBlur={(): void => setShouldAnimate(false)}
          onChange={changeHandler}
          placeholder={placeholder}
          ref={inputRef}
          data-testid="test__data-table-search-bar"
          defaultValue={value}
        />
        <label htmlFor={id} className="caprx-f-elem-label">
          {label}
        </label>
      </div>
    </>
  );
};

export default SearchBar;
